import { UserSummaryController } from './userSummary.controller';
import template from './userSummary.html';

export const userSummaryComponent = {
  name: 'userSummaryComponent',
  restrict: 'E',
  template,
  controller: UserSummaryController,
  controllerAs: 'vm',
  bindings: {
    user: '<',
    isEmployee: '<',
    hideIbans: '<',
    ticketType: '<',
    onChangeEmployeeStatus: '&',
  },
};
